import React from 'react';

import { themeStore } from 'Models/ThemeStore';
import { bookingTransactionStatus } from 'Models/Enums';
import { useIntl } from 'react-intl';
import { Tag } from 'Views/Components/_HumanWritten/CheckIn/FerryCheckIn/CheckInList/Tag';

export enum BookingStatusTagOption {
	PAID = 'PAID',
	CANCELLED = 'CANCELLED',
	AWAITING = 'AWAITING',
	INVOICED = 'INVOICED',
	UNPAID = 'UNPAID',
}

export interface BookingStatusTagProps {
	status?: bookingTransactionStatus;
	isStaff?: boolean;
}

export function BookingStatusTag({ status, isStaff }: BookingStatusTagProps) {
	const intl = useIntl();
	let text = '';
	let customColour = '';
	let customTextColour = '';

	switch (status) {
		case BookingStatusTagOption.CANCELLED:
			text = intl.formatMessage({
				id: 'booking-status__cancelled__label',
				defaultMessage: 'Cancelled',
			});
			customColour = themeStore.cancelledTagColour;
			customTextColour = themeStore.textOnCancelledTag;
			break;
		case BookingStatusTagOption.AWAITING:
			text = intl.formatMessage({
				id: 'booking-status__awaiting__label',
				defaultMessage: 'Awaiting',
			});
			customColour = themeStore.awaitingTagColour;
			customTextColour = themeStore.textOnAwaitingTag;
			break;
		case BookingStatusTagOption.INVOICED:
			text = intl.formatMessage({
				id: 'booking-status__invoiced__label',
				defaultMessage: 'Invoiced',
			});
			customColour = themeStore.invoicedTagColour;
			customTextColour = themeStore.textOnInvoicedTag;
			break;
		case BookingStatusTagOption.UNPAID:
			text = intl.formatMessage({
				id: 'booking-status__unpaid__label',
				defaultMessage: 'Unpaid',
			});
			customColour = themeStore.awaitingTagColour;
			customTextColour = themeStore.textOnInvoicedTag;
			break;
		default:
			text = intl.formatMessage({
				id: 'booking-status__booked__label',
				defaultMessage: 'Booked',
			});
			if (isStaff) {
				text = intl.formatMessage({
					id: 'booking-status__paid__label',
					defaultMessage: 'Paid',
				});
			}
			customColour = themeStore.paidTagColour;
			customTextColour = themeStore.textOnPaidTag;
			break;
	}

	return (
		<div className="tag__container">
			<Tag
				text={text}
				customStyles={{
					background: customColour,
					color: customTextColour,
				}}
			/>
		</div>
	);
}
